module.exports = __webpack_public_path__ + "static/media/cheese.1d4de523.svg";